module.exports = __webpack_public_path__ + "static/img/checkpoint1EN.d72575b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/journey/checkpoint1EN.png
// module id = 9PDn
// module chunks = 0